// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1869":"df934a670bd9c37b","6451":"44f84c837b2e05e2","7701":"cd1c10cebf539d69"}[chunkId] + ".css";
};